import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function CallbackPage({ userManager, onRedirectSuccess }) {
  const onRedirectError = error => {
    console.error('OAuth Callback Error:', error);
    console.error('Error details:', {
      message: error.message,
      stack: error.stack,
      sessionStorage: Object.keys(sessionStorage),
      currentURL: window.location.href
    });

    // If state is missing, redirect back to login
    if (error.message && error.message.includes('No matching state')) {
      console.warn('State validation failed - redirecting to login');
      window.location.href = '/';
      return;
    }

    throw new Error(error);
  };

  useEffect(() => {
    console.log('CallbackPage: Starting OAuth callback handling');
    console.log('Current URL:', window.location.href);
    console.log('SessionStorage keys:', Object.keys(sessionStorage));

    userManager
      .signinRedirectCallback()
      .then(user => {
        console.log('OAuth callback successful:', user);
        onRedirectSuccess(user);
      })
      .catch(error => onRedirectError(error));
  }, [userManager, onRedirectSuccess]);

  return null;
}

CallbackPage.propTypes = {
  userManager: PropTypes.object.isRequired,
};

export default CallbackPage;
